import { api } from 'utils/network/api';
import { axios } from 'utils/network/axios';

const url = process.env.REACT_APP_BASE_URL;

class TierService {
  list(body) {
    return api({
      baseUrl: url,
      endpoint: '/tier-level/list',
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
  }

  post(body) {
    return axios.post('/tier-level', body);
  }

  put(body) {
    return axios.put(`/tier-level/${body.id}`, body);
  }

  delete(id) {
    return axios.delete(`/tier-level/${id}`);
  }
}

export default new TierService();
